<template>
    <div class="mt-8 py-2">
        <div
            @click="$emit('closed')"
            class="btn btn-square btn-sm btn-ghost absolute top-0 right-0 m-1 close-z-100"
        >
            <span class="material-symbols-outlined notranslate fill-current">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 -960 960 960"
                    width="24"
                >
                    <path
                        d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
                    />
                </svg>
            </span>
        </div>
        <div class="mb-1 mx-4 flex justify-between">
            <div class="text-lg font-extrabold m-1 pb-2 mx-2">
                {{ trans.routes.route_ttl }}
            </div>
            <div class="btn btn-sm rounded-full normal-case z-100" @click="closeDetail">
                {{ trans.routes.clear }}
                <span v-if="currentRoute" class="inline-flex rounded-full h-3 w-3 bg-primary z-10"></span>
            </div>
        </div>
        <div class="overflow-y-auto h-screen routes-content-height">
            <div>
                <div
                    class="route-item flex-col-reverse"
                    @click="choose(route)"
                    v-for="route in routes"
                    :key="'route-' + route.id"
                    :id="'route-' + route.id"
                >
                    <a>
                        <div
                            class="card rounded m-2 shadow transition-all duration-200"
                            :class="{
                                'hidden':
                                    currentRoute &&
                                    currentRoute.id !== route.id &&
                                    currentRoute.id !== null,
                                'hover:scale-[1.02] hover:bg-base-200': !(
                                    currentRoute && currentRoute.id === route.id
                                )
                            }"
                        >
                            <div
                                class="card-body ml-1 p-0 py-3"
                                :style="{
                                    'border-style': 'solid',
                                    'border-left-width': '5px',
                                    'border-left-color': route.line_color
                                }"
                            >
                                <div v-if="route.image_url" class="mx-2"
                                    :class="{
                                            'w-route-img': !(
                                                currentRoute && currentRoute.id === route.id
                                            )
                                        }"
                                >
                                    <img :src="route.image_url" class="rounded-lg">
                                </div>
                                <div class="mx-2 my-2">
                                    <div>
                                        <div
                                            class="text-base-content mb-1 font-bold text-base break-words text-overflow-wrap"
                                        >
                                            {{ route.title }}
                                        </div>
                                        <div
                                            class="text-base-content/80 text-sm break-words text-overflow-wrap"
                                        >
                                            {{ route.sub_title }}
                                        </div>
                                    </div>
                                    <div
                                        class="text-base-content text-base font-medium text_overflow pb-0 break-words text-overflow-wrap mt-5"
                                        v-if="currentRoute && currentRoute.id === route.id"
                                    >
                                        <span v-readMore:150="route.description"></span>
                                    </div>
                                </div>
                                <div
                                    v-if="routeLocations.length > 0 && currentRoute.id === route.id"
                                    class="route-list"
                                >
                                    <div class="divider my-1 mx-2"></div>
                                    <table class="table overflow-visible p-0 floor-content-height">
                                        <tbody>
                                        <div class="ext-sm font-bold my-2 ml-4 text-base-content text-opacity-50">{{ trans.routes.related_to_route }}</div>
                                        <tr
                                            v-for="location in routeLocations"
                                            :key="'location-' + location.properties.id"
                                            :id="'location-' + location.properties.id"
                                            @click="chooseLocation(location.properties.id)"
                                            class="hover"
                                        >
                                            <td class="flex items-center space-x-2 px-2">
                                                <div class="">
                                                    <div
                                                        class="mask mask-squircle bg-base-content h-16 w-16 bg-opacity-10 p-px"
                                                    >
                                                        <img
                                                            class="mask mask-squircle w-full h-full object-cover bg-primary"
                                                            :src="location.properties.marker_image_url"
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="text-sm font-bold">
                                                        {{ location.properties.title }}
                                                    </div>
                                                    <div class="text-base-content/70 text-xs">
                                                        {{ location.properties.sub_title }}
                                                    </div>
                                                    <div class="btn btn-xs disabled rounded-full normal-case">
                                                        {{ location.properties.category.title }}
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="text-center mt-4 mx-4" v-if="currentRoute">
                    <button 
                        class="btn btn-circle z-100 relative"
                        @click="closeDetail"
                    >
                        <span class="material-symbols-outlined notranslate fill-current">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>                                </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import * as turf from '@turf/turf';
import RouteHelper from '../mixins/Route';
import BottomSheet from './BottomSheet';
import ReadMoreDirective from '../custom_directives/ReadMore';

export default {
    inject: ['mapId', 'locale'],
    mixins: [RouteHelper],
    directives: {
        readMore: ReadMoreDirective
    },
    components: {
        BottomSheet
    },
    props: {
        mySmartMap: {
            type: Object,
            required: false
        },
        filterLocationsByRoute: {
            type: Function,
            required: true
        },
        showListRoute: {
            type: Boolean,
            required: true
        },
        trans: {
            type: Object,
            required: true
        },
        routeLocations: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    data() {
        return {
            routes: [],
            currentRoute: null
        };
    },
    created() {
        this.getRoutes();
    },
    methods: {
        transformCamera(coordinates) {
            var line = turf.lineString(coordinates[0]);
            var bbox = turf.bbox(line);
            const newCameraTransform = this.mySmartMap.cameraForBounds(bbox, {
                padding: { top: 10, bottom: 35, left: 15, right: 15 }
            });
            this.mySmartMap.flyTo(newCameraTransform);
        },
        getRoutes() {
            axios
                .get(`/api/maps/${this.mapId}/routes?locale=${this.locale}`)
                .catch(function (error) {
                    console.log(error.toJSON());
                })
                .then((response) => {
                    this.routes = response.data;
                    this.$emit('showRouteBtn', this.routes.length > 0);
                    this.getRouteOnParam();
                });
        },
        choose(route) {
            this.currentRoute = route;
            this.showRoute(this.currentRoute);
        },
        scrollToLeft(value) {
            this.$refs.scrollContainer.scrollLeft += value;
        },
        closeDetail() {
            if (!this.currentRoute) {
                return;
            }
            this.hideRoute(this.currentRoute);
            this.currentRoute = null;
            this.addRouteParamToURL();
            this.filterLocationsByRoute(this.currentRoute);
        },
        getRouteOnParam() {
            const params = new URLSearchParams(window.location.search);
            this.currentRoute = this.routes.find((e) => {
                return e.id == params.get('route');
            });
        },
        chooseLocation(id) {
            this.$emit('chooseLocation', id);
        },
        addRouteParamToURL() {
            const routeId = this.currentRoute?.id;
            let routeQuery = routeId && routeId > 0 ? `?route=${routeId}` : '';
            const newUrl = window.location.pathname + routeQuery;
            window.history.replaceState(null, null, newUrl);
        }
    },
    watch: {
        currentRoute(newVal, oldVal) {
            this.mySmartMap.once('idle', () => {
                this.filterLocationsByRoute(newVal);
            });
            if (newVal) {
                this.showRoute(newVal);
                this.transformCamera(newVal.coordinates);
                this.$emit('toggledSubSidebar', 'routeBox');
                this.addRouteParamToURL();
            }
            if (oldVal) {
                this.hideRoute(oldVal);
            }
        }
    }
};
</script>

<style>
.w-route {
    width: 16rem;
    overflow-wrap: anywhere;
    text-align: start;
}
.text-overflow-wrap {
    overflow-wrap: anywhere;
}
.routes-content-height {
    padding-bottom: 40rem;
}
.w-route-img {
    width: 7rem;
}
@media screen and (max-width: 639px) {
    .routes-content-height {
        min-height: 40rem;
        padding-bottom: 40rem;
    }
}
</style>
